import React from 'react';
import { SolutionDetailTemplate } from '../shared/SolutionDetailTemplate';

export const OperationalIntelligenceAutomationPage: React.FC = () => {
  return (
    <SolutionDetailTemplate
      title="Operational Intelligence & Automation"
      description="We integrate IoT, AI, and advanced analytics to optimize operations, eliminate inefficiencies, and enable real-time, data-driven decisions."
      category="Smart Operations"
      categoryColor="#00CFFF"
      keyFeatures={[
        "Real-time sensor integration with anomaly detection",
        "Automated alerts, dashboards, and seamless data flow",
        "Digital tools for task tracking, HR automation, and centralized visibility",
        "Predictive maintenance and equipment monitoring",
        "Resource optimization and workflow automation",
        "Performance analytics and operational insights"
      ]}
      benefits={[
        "Reduce operational downtime by up to 70%",
        "Improve resource utilization and efficiency",
        "Enable proactive maintenance strategies",
        "Streamline workflow management processes",
        "Reduce manual tasks and human errors",
        "Real-time visibility into operations",
        "Data-driven decision making capabilities"
      ]}
      useCases={[
        "Manufacturing equipment monitoring and predictive maintenance",
        "Supply chain optimization and tracking",
        "Energy management and consumption optimization",
        "Quality control and process automation",
        "Workforce management and task automation",
        "Facility management and space utilization",
        "Inventory management and stock optimization",
        "Performance monitoring and KPI tracking"
      ]}
      relatedTools={[
        {
          name: "Planfusion",
          description: "Automates lead capture, dedupe, routing, and follow‑ups to speed conversions.",
          href: "/products/ai/planfusion"
        },
        {
          name: "ManageRTC",
          description: " Automates onboarding, attendance, payroll, and HR workflows with self‑serve portals.",
          href: "/products/it/ManageRTC"
        },
        {
          name: "Panaceon",
          description: "Auto‑codes encounters and drafts audit trails to cut throughput time.",
          href: "/products/ai/Panaceon"
        },
        {
          name: "Whishperagon",
          description: "Conversational assistant to handle FAQs, ticket triage, and internal requests.",
          href: "/products/ai/whisperagon"
        },
        {
          name: "Predictive Maintenance",
          description: "Automates work orders and service scheduling based on asset health signals.",
          href: "/products/iot/water-level-iot"
        },
        {
          name: "MVS x AI",
          description: "Auto‑flags PPE violations and triggers corrective workflows.",
          href: "/products/ai/predictivemaintenance"
        },
        {
          name: "Asset Management",
          description: " Event‑driven alerts, geo‑fencing, and escalation playbooks.",
          href: "/products/ai/assetmanagement"
        },
        {
          name: "AI Cooler",
          description: "Closed‑loop set‑point control to stabilize temperature and reduce energy use.",
          href: "/products/ai/aicooler"
        },
        {
          name: "Water Level IoT",
          description: " Sensor‑driven monitoring with threshold alerts and pump automation.",
          href: "/products/ai/aicooler"
        },
        {
          name: "Finance Policy Check",
          description: " Autonomously reconciles, categorizes, and posts routine finance transactions.",
          href: "/products/ai/financepolicycheck"
        }
      ]}
      industries={[
        "Manufacturing & Industrial",
        "Oil & Gas Operations",
        "Construction & Infrastructure",
        "Energy & Utilities",
        "Logistics & Supply Chain"
      ]}
    />
  );
};